import type { ViewSwitcherOption, ViewSwitcherOptions } from './ViewSwitcher.types';

export function resolveSelectedOption(
    value: number | ViewSwitcherOption | undefined,
    displayedOptions: ViewSwitcherOptions,
    current?: ViewSwitcherOption
): ViewSwitcherOption | undefined {
    if (typeof value !== 'number') {
        return value;
    }

    const match = displayedOptions.find(({ id }) => id === value);
    if (match) {
        return match;
    }

    if (value && current?.id === value) {
        return current;
    }

    return undefined;
}
